module.exports = __webpack_public_path__ + "assets/835805c7d68ccc7c2bc8051defa02cda.mp3";